// Reminders the card's pickers set, on the to-do's day (Todo.setReminder, reminderDay and reminderHasPassed in the kit;
// their copies are the core's, core/repeats.ts). Quick Entry itself is the data layer's (data/quickEntry.ts,
// Store.quickAdd).

import { at, dayOf } from "../core/days";
import { knownZone, reminderClock } from "../core/repeats";
import type { Todo } from "../core/records";
import type { Day } from "../core/types";

export { reminderDay, reminderHasPassed, reminderMovesToToday, setReminder } from "../core/repeats";

/**
 * A reminder moved to another day, keeping its time on the clock (when the start changes): read where it was set
 * (`reminderZone`, docs/48), set again here, where the store then notes this zone.
 */
export function reminderOnDay(todo: Pick<Todo, "reminder" | "reminderZone">, day: Day, zone: string): Date | undefined {
  if (!todo.reminder) return undefined;
  const there = knownZone(todo.reminderZone) ?? zone;
  if (there === zone && dayOf(todo.reminder, zone) === day) return todo.reminder;
  const clock = reminderClock(todo, zone) ?? { hour: 9, minute: 0 };
  return at(day, clock.hour, clock.minute, zone);
}
